import { dedupedGet } from '../apiClient';

export const dashboardService = {
  // Main Dashboard APIs
  getUsage24h: () => dedupedGet('messaging/usage-24h'),
  getConversationsMonth: () => dedupedGet('messaging/conversations-month'),
  getQualityMetrics: () => dedupedGet('messaging/quality-metrics'),
  getEntitySummary: () => dedupedGet('messaging/entity-summary'),

  // Platform Overview APIs
  getPlatformOverview: () => dedupedGet('admin/platform/overview'),
  getCampaignCost: (period) => dedupedGet(`admin/platform/campaign-cost?period=${period}`),
  getOutgoingMessages: (period) => dedupedGet(`admin/platform/outgoing-messages?period=${period}`),
  getLowBalanceUsers: (scope = 'all') =>
    dedupedGet(`admin/platform/low-balance-users?scope=${scope}`),
};
